module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASJJREFUSA3tU70ZgkAM5WcBOwqGkBFwA0dhFLew1cpS3eDYgtLSBvA9JHwRc8hnqVyTkLy8d5eEIFjOz3cgtl6Y4aRpuk+S5FhV1d3CSAzQFbAnYEtgK4mLjcTRNoqiHb7zOI7PJNA57TNHDLF9jU53vinQNM22bdsSiMwnosgzYlnzxo5AaAUZIwFudQnDcI1PV9f1xjl3k1x/cyHPJce8Pl4BgiwRxueSEzspQMBYhDGcjzd/wmYIdGyv7Qr6nnvbIuS05pA1QHzMorV8ifnsrBbpnpPIGvxXAsYq5iTybZcl4n2BRS6rOB68XuGxiCkwRS4Ec0XMIaMFBxBNriJfg783lz++rxH9wZoCKCxQeCWBtGWoUI4SIbZQqcX9pw48AIUz3dKpXBNaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/ic_clear_24px.png
// module id = 30
// module chunks = 0